import React from 'react'
import MaterialSymbol from '../material-symbol'

const Home = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="home" {...props} />
))

Home.displayName = 'Home'

export default Home
